<google-map #mapElement
    [center]="location"
    [options]="options"
    [zoom]="zoom"
    height="100%"
    width="100%"
    frameborder="0"
    style="border:0;"
    allowfullscreen=""
    aria-hidden="false"
    tabindex="0"
    aria-label="map">

    <map-marker #markerElement="mapMarker"
        *ngFor="let marker of markers"
        [position]="marker.position"
        [label]="marker.label"
        [title]="marker.title"
        [options]="marker.options"
        (mapClick)="onMapMarkerClicked(markerElement, marker.info)">
    </map-marker>

    <map-info-window [innerHTML]="infoWindowContent"></map-info-window>
</google-map>
